import React, { useState } from 'react';
import './Products.css';
import ProductCard from './ProductCard';
import Laptop1 from './assets/laptop-1.jpeg';
import Laptop2 from './assets/laptop-2.jpeg';
import Laptop3 from './assets/laptop-3.jpeg';
import Laptop4 from './assets/laptop-4.jpeg';
import Laptop5 from './assets/laptop-5.jpeg';
import Laptop6 from './assets/laptop-6.jpeg';

export const laptops = [
    {
        title: 'Dell Laptop',
        subtitle: 'Sleek Design',
        src: Laptop2,
        price: 500,
        quantity: 0
        
    },
    {
        title: 'HP Laptop',
        subtitle: 'Powerful Performance',
        src: Laptop1,
        price: 600,
        quantity: 0
        
    },
    {
        title: 'Asus Laptop',
        subtitle: 'Innovative Features',
        src: Laptop3,
        price: 700,
        quantity: 0
        
    },
    {
        title: 'Lenovo Legion Pro 7i',
        subtitle: 'Top-end performance',
        src: Laptop4,
        price: 1200,
        quantity: 0
    },
    {
        title: 'Gigabyte G5',
        subtitle: 'Powerhouse in compact form',
        src: Laptop5,
        price: 1300,
        quantity: 0
    },
    {
        title: 'Razer Blade 14',
        subtitle: 'Travel-friendly powerhouse',
        src: Laptop6,
        price: 1400,
        quantity: 0
    }
    
];

export const powerLaptops = [
        {
            title: 'Lenovo Legion Pro 7i',
            subtitle: 'Top-end performance',
            src: Laptop4,
            price: 1200,
            quantity: 0
        },
        {
            title: 'Gigabyte G5',
            subtitle: 'Powerhouse in compact form',
            src: Laptop5,
            price: 1300,
            quantity: 0
        },
        {
            title: 'Razer Blade 14',
            subtitle: 'Travel-friendly powerhouse',
            src: Laptop6,
            price: 1400,
            quantity: 0
        },
        {
            title: 'Dell Laptop',
            subtitle: 'Sleek Design',
            src: Laptop2,
            price: 500,
            quantity: 0
        },
        {
            title: 'HP Laptop',
            subtitle: 'Powerful Performance',
            src: Laptop1,
            price: 600,
            quantity: 0
        },
        {
            title: 'Asus Laptop',
            subtitle: 'Innovative Features',
            src: Laptop3,
            price: 700,
            quantity: 0
        }
    ];

function Products({ addToCart, setCart, removeFromCart, updateQuantity}) {
    

    const [selectedOption, setSelectedOption] = useState('EVERYDAY USE');

    const handleOptionClick = (option) => {
        setSelectedOption(option); 
    };

    

    return (
        <div className='products-part pt-5 pb-5' id='products'>
            <div>
                <h2 className='products-heading pb-4 pt-5'>Our Top Picks</h2>
            </div>
            <div className='product-selection'>
                <p className={selectedOption === 'EVERYDAY USE' ? 'selected' : ''} onClick={() => handleOptionClick('EVERYDAY USE')}>
                    EVERYDAY USE
                </p>
                <p className={selectedOption === 'POWER MACHINES' ? 'selected' : ''} onClick={() => handleOptionClick('POWER MACHINES')}>
                    POWER MACHINES
                </p>
            </div>
            <hr className='long-line' />
            <div className='products-container container pt-3 pb-3'>
                <div className='products row '>
                    
                        {selectedOption === 'EVERYDAY USE' &&
                            laptops.map((laptop, index) => (
                                <div className='col-12 col-md-6 col-lg-4 mt-2 mb-3' key={index}>
                                <ProductCard
                                    key={index}
                                    title={laptop.title}
                                    subtitle={laptop.subtitle}
                                    src={laptop.src}
                                    price={laptop.price}
                                    addToCart={addToCart} 
                                    setCart={setCart}
                                    removeFromCart={removeFromCart}
                                    
                                    quantity={laptop.quantity}
                                    updateQuantity={(newQuantity) => updateQuantity(index, newQuantity)}

                                />
                                </div>
                            ))
                        }
                        {selectedOption === 'POWER MACHINES' &&
                            powerLaptops.map((powerLaptop, index) => (
                                <div className='col-12 col-md-6 col-lg-4 mt-2 mb-3' key={index}>
                                <ProductCard
                                    key={index}
                                    title={powerLaptop.title}
                                    subtitle={powerLaptop.subtitle}
                                    src={powerLaptop.src}
                                    price={powerLaptop.price}
                                    addToCart={addToCart} 
                                    setCart={setCart}
                                    removeFromCart={removeFromCart}
                                    updateQuantity={(newQuantity) => updateQuantity(index, newQuantity)}
                                    
                                    quantity={powerLaptop.quantity}
                                />
                                </div>
                            ))
                        } 
                    
                      
                    
                </div>
            </div>
        </div>
    )
}

export default Products;